import Chart from 'chart.js/auto';

Chart.defaults.scale.grid.display = false;
Chart.defaults.scale.ticks.display = false;
Chart.defaults.fontFamily = 'opensans-regular';
Chart.defaults.color = '#000';
Chart.defaults.fontSize = 15;
Chart.defaults.responsive = true;
Chart.defaults.maintainAspectRatio = false;
